@if (item) {
  <div>
    @if (item.headline && !contentEdit) {
      <h3 style="margin-bottom: 20px">{{ item.headline }}</h3>
    }
    @if (contentEdit) {
      <coin-v2-text-input
        [label]="'cms.content-pages.headline' | translate"
        [placeholder]="'Headline'"
        [(ngModel)]="item.headline" />
    }
    <!-- <h3 style="margin-bottom: 20px;" *ngIf="item.headline && contentEdit" [contentEditable]="contentEdit" [textContent]="item.headline" (input)="item.headline = $event.target.textContent ? $event.target.textContent : 'headline'"></h3> -->
    @if (contentEdit) {
      <coin-html-editor
        [item]="item"
        [contentEdit]="true"
        [isNews]="true"></coin-html-editor>
    }
    @if (!contentEdit) {
      <p
        class="text-block-content"
        style="column-gap: 20px"
        [ngStyle]="{ 'column-count': item.columns ? item.columns : 1 }"
        [innerHTML]="adjustedText"></p>
    }
    <!-- <p [ngStyle]="{'column-count': item.columns ? item.columns : 1}" *ngIf="contentEdit" [contentEditable]="contentEdit" [textContent]="item.text" (input)="item.text = $event.target.textContent ? $event.target.textContent : 'text'" style="column-gap: 20px;"></p> -->
  </div>
}
@if (contentEdit && item) {
  <div style="margin-top: 20px">
    <coin-v2-number-input
      aria-label="amount columns"
      [label]="'cms.columns' | translate"
      [placeholder]="'cms.amount-columns' | translate"
      [disabled]="!contentEdit"
      [(ngModel)]="item.columns" />
  </div>
}
